export enum ModuleSort {
	NAME = 'NAME',
}
